import { useEffect, useState } from "react";
import HardwareDetailsComponent from "./HardwareDetailsComponent";
import DeviceColumnComponent from "./DeviceColumnComponent";

const ProductOrderDetails = ({
  orderId,
  productOrderData,
  productType,
  expand,
  disableAllActions,
  onDeviceTriggerStatusUpdated,
  onOrderStatusUpdated,
  deviceActionStatus,
  triggeredAll,
  oneNucleusValid,
}) => {
  const [deviceData, setDeviceData] = useState([]);
  const [hardwareData, setHardwareData] = useState([]);
  const [allTriggered, setTriggeredAllQC] = useState(false);

  useEffect(() => {
    setTriggeredAllQC(triggeredAll);
  }, [triggeredAll]);

  useEffect(() => {
    if (productOrderData) {
      groupedDeviceInfo(productOrderData?.deviceInfo);
    }
  }, [productOrderData]);

  useEffect(() => {
    groupedHardwareInfo(productOrderData?.deviceInfo);
  }, [deviceData]);

  const onDeviceQCStatusUpdated = (count) => {
    onDeviceTriggerStatusUpdated(count);
  };

  const onOverallStatusUpdated = (enable) => {
    onOrderStatusUpdated(enable);
  };

  const groupedDeviceInfo = (deviceInfo) => {
    const grouped = deviceInfo.reduce((accumulator, currentItem) => {
      // Get the group keys
      const { deviceType, deviceModel, isTechbook } = currentItem;
      const techbookKey = isTechbook ? "TECHBOOK" : "NON_TECHBOOK";

      // If a group with deviceType doesn't exist, create it
      if (!accumulator[deviceType]) {
        accumulator[deviceType] = {};
      }

      // If a group with deviceModel doesn't exist within deviceType, create it
      if (!accumulator[deviceType][deviceModel]) {
        accumulator[deviceType][deviceModel] = {};
      }

      // Push the current item into the group
      if (!accumulator[deviceType][deviceModel][techbookKey]) {
        accumulator[deviceType][deviceModel][techbookKey] = [];
      }
      accumulator[deviceType][deviceModel][techbookKey].push(currentItem);
      return accumulator;
    }, {});

    setDeviceData(grouped);
  };

  const groupedHardwareInfo = (deviceInfo) => {
    const grouped = deviceInfo.reduce((accumulator, currentItem) => {
      // Get the key to group by
      const deviceModel = currentItem.deviceModel;
      const techbookKey = currentItem.isTechbook ? "TECHBOOK" : "NON_TECHBOOK";

      // If the key doesn't exist in the accumulator, create a new array for it
      if (!accumulator[deviceModel]) {
        accumulator[deviceModel] = {};
      }

      if (!accumulator[deviceModel][techbookKey]) {
        accumulator[deviceModel][techbookKey] = [];
      }

      // Add the current item to the array for the key
      accumulator[deviceModel][techbookKey].push(currentItem);

      return accumulator;
    }, {});
    setHardwareData(grouped);
  };

  return (
    <div className="product-card-container">
      {!expand && (
        <div className="order-column-container">
          <HardwareDetailsComponent
            productType={productType}
            groupId={productOrderData.groupId}
            hardwareDetails={hardwareData}
            expand={expand}
          />
        </div>
      )}
      <div
        className="collapsible-hardware-info-card"
        style={{
          height: expand ? "100%" : "0px",
        }}
      >
        {productOrderData && (
          <div className="device-column-container">
            <DeviceColumnComponent
              orderId={orderId}
              disableAllActions={disableAllActions}
              productType={productType}
              groupId={productOrderData.groupId}
              schoolId={productOrderData.schoolId}
              schoolName={productOrderData.schoolName}
              packageName={productOrderData.packageName}
              appVersion={productOrderData.appVersion}
              loginId={productOrderData.loginId}
              password={productOrderData.password}
              oneNucleusValid={oneNucleusValid}
              deviceMapData={hardwareData}
              allTriggered={allTriggered}
              expand={expand}
              deviceActionStatus={deviceActionStatus}
              onDeviceQCStatusUpdated={onDeviceQCStatusUpdated}
              onOverallStatusUpdated={onOrderStatusUpdated}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductOrderDetails;
